import { render, staticRenderFns } from "./ChildIcon.vue?vue&type=template&id=2cdadd17&scoped=true"
import script from "./ChildIcon.vue?vue&type=script&lang=js"
export * from "./ChildIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdadd17",
  null
  
)

export default component.exports